export default __webpack_public_path__ + "bb2f1c87429a3da626e9c95435870eea.png";